import React, {useEffect} from "react";
import {Col, Form, Row, Button, ButtonGroup } from "react-bootstrap";
import { MdEmail } from "react-icons/md";
import { useForms } from "./../../use-forms/index"
import cpfCnpj from '../../helpers/cpf-cnpj-helper'
import phoneNumber from '../../helpers/phone-number-helper'
import { z } from "zod"

const preprocess = (value) => (!!value ? value : undefined)
const formSchema = z.object({

  document: z.preprocess(
    preprocess,
    z.coerce.string()
      .nonempty("CPF é obrigatório.")
      .refine((value) => {
        //@to-do Check CPF gov.br endpoint
        // https://www.gov.br/conecta/catalogo/apis/cadastro-base-do-cidadao-cbc-cpf/swagger_cpf_light.json/swagger_view
        return cpfCnpj.unmask(value)?.length == 11 || value?.length == 14
      }, "No campo CPF, deve conter no máximo 14 caracteres.")
  ),
  phone: z.preprocess(
    preprocess,
    z.coerce.string()
      .nonempty("Número do telefone é obrigatório.")
      .refine((value) => {
        return phoneNumber.unmask(value)?.length === 11
      }, "É permitido apenas número de telefone válido.")
  ),
})

//Form step 2
function Index(props) {
  const {
    register,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForms({ validator: formSchema })

  useEffect(() => {
    clearErrors()
    setValue('document', cpfCnpj.mask(props.form.document, 'cpf'))
    setValue('phone', phoneNumber.mask(props.form.phone))
  }, [])

  const onSubmitForm = data => {
    //post or validate data to/on api endpoint here
    //on success
    props?.submit({
      ...data,
      cpf: cpfCnpj.unmask(data.document),
      phone: phoneNumber.unmask(data.phone),
    })
  }

  return (
    <Form onSubmit={handleSubmit(onSubmitForm)} className="col-12 col-md-5 col-lg-4">
      <div className="background"></div>
      <h2 className="mb-3"><MdEmail/> Contato</h2>
      <p>Preencha os campos correspondentes às suas informações de contato, e salve para continuar.</p>
      <Row>
        <Form.Group as={Col} className="mb-3 col-12">
          <Form.Label column sm="5">
            CPF
          </Form.Label>
          <Col sm="12">
            <Form.Control className="mb-3" {...register('document')} onChange={e => cpfCnpj.mask(e, 'cpf')} />
            {errors.document?.message && <div className="text-danger">{errors.document?.message}</div>}
          </Col>
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} className="mb-3 col-12">
          <Form.Label column sm="5">
            Número do celular
          </Form.Label>
          <Col sm="12">
            <Form.Control className="mb-3" {...register('phone')}  onChange={phoneNumber.mask}  />
            {errors.phone?.message && <div className="text-danger">{errors.phone?.message}</div>}
          </Col>
        </Form.Group>
      </Row>

      <ButtonGroup className="col-12 mt-5">
        <Button onClick={props?.back} className="btn btn-light btn-large" type="button">Voltar</Button>
        <Button className="btn btn-primary btn-large centerButton" type="submit">Salvar</Button>
      </ButtonGroup>
    </Form>
  );
}

export default Index;
